import styled from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper/";

export const FormField = styled.div.attrs(({ smallRow }) => ({
  smallRow: smallRow ? "row" : "column",
}))`
  input {
    border-color: ${({ error, theme }) =>
      error ? `${theme.colors.error} !important` : ""};
  }

  display: flex;
  flex-direction: ${({ row }) => (row ? "row" : "column")};
  padding: ${({ padding }) => (padding ? padding : "0 0 20px 0rem")};
  width: ${({ half }) => (half ? "50%" : "100%")};
  align-self: ${({ half }) => (half ? "flex-start" : "")};
  align-items: ${({ center }) => (center ? "center" : "")};
  ${media.lessThan(breakpoints.mobile)`
		flex-direction: ${({ smallRow }) => smallRow};
  `}
  &:first {
    padding: ${({ padding }) => (padding ? padding : "20px 0 20px 0rem")};
  }
`;

export const Label = styled.span`
  display: ${({ hide }) => (hide ? "none" : "")};
  margin-bottom: ${({ removeMarginBottom }) =>
    removeMarginBottom ? "0" : " 0.5rem"};
  font-weight: bold;
  color: ${({ error, theme }) => (error ? theme.colors.error : "black")};
  margin-right: ${({ addMarginRight }) => (addMarginRight ? "0.5rem" : " 0")};
`;

export const FieldForm = styled.form`
  padding: ${({ padding }) => (padding ? padding : "20px 0 0 0rem")};
`;
